export default {
  props: {
    /** Overrides input id */
    customInputId: {
      type: String,
      default: null,
    },
    /** Overrides input name */
    customInputName: {
      type: String,
      default: null,
    },
  },
}
